const menuenuItemsReceived = 'MENU_ITEMS_RECEIVED';
const requestingMenuItems = 'REQUESTING_MENU_ITEMS';
const initialState = { menuItems: [] };

export const actionCreators = {

	getMenuItems: () => async (dispatch) => {		

		const url = 'api/menuitems/';
		const response = await fetch(url);
		if (response.ok) {
			dispatch({ type: requestingMenuItems });

			const menuItems = await response.json();

			dispatch({ type: menuenuItemsReceived, menuItems });
		}
	}
};

export const reducer = (state, action) => {
	state = state || initialState;

	if (action.type === menuenuItemsReceived) {		
		return {
			...state,
			menuItems: action.menuItems,
		};
	}
	return state;
};


// WEBPACK FOOTER //
// ./src/store/Navigation.js